<template>
  <v-container>
    <v-card>
      <v-layout>
        <v-flex>
          <v-toolbar color="white" dark flat dense cad>
            <v-toolbar-title class="indigo--text"
              >Gestion de documentos</v-toolbar-title
            >
          </v-toolbar>
        </v-flex>
      </v-layout>
      <v-layout justify-center>
        <v-flex xs1></v-flex>
        <v-flex xs1></v-flex>
        <v-flex xs12 md3>
          <v-text-field
            v-model="asuntoDocumento"
            label="Asunto Documento"
          ></v-text-field>
        </v-flex>
        <v-flex xs1></v-flex>
        <v-flex xs12 md3>
          <br />
          <data-adjunto
            :key="adminAdjunto"
            :tipeArchive="tipeArchive"
          ></data-adjunto>
        </v-flex>
        <v-flex>
          <v-card-actions class="pb-3" >
            <v-btn
            v-if="
              getCodigoPerfil != 'LEC' 
            "
            
              :loading="loading"
              color="success"
              dark
              class="mb-2"
              @click="saveDocument"
              >Nuevo</v-btn>
          </v-card-actions>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex>
          <grid-administrativo-contractual
            :key="adminGrid"
          ></grid-administrativo-contractual>
        </v-flex>
      </v-layout>
    </v-card>
  </v-container>
</template>

<script>
import Vue from "vue";
import jwtDecode from "jwt-decode";
import GridAdministrativoContractual from "@/modules/configuration/informacionContractual/views/GridAdministrativoContractual.vue";
import axios from "axios";
import DataAdjunto from "@/components/AdjuntoData.vue";

export default {
  name: "administrativo-sub-tab",
  components: {
    GridAdministrativoContractual,
    DataAdjunto,
  },
  props: {
    proveedor: {},
    show: Boolean,
    tipeView: "",
  },
  data() {
    return {
      contratoId: "",
      allowSpaces: false,
      valid: false,
      procesoValue: null,
      procesoSelect: [],
      asuntoDocumento: "",
      filter: false,
      adminGrid: 0,
      adminAdjunto: 10,
      usuarioLoggedTipe: "",
      tipeArchive: "",
      alerta: false,
      loading: false,
      idContratoSelect: [],
      idContratoValue: "",
    };
  },

  computed: {
    getCodigoPerfil() {
      const token = localStorage.getItem("token");
      const decoded = jwtDecode(token);
      const user = decoded.dto;
      console.log("DEVODED USER:", user);
      return user.perfil.codigo;
    }
  },

  created() {
    this.contratoId = this.$store.getters.contratoStored;
    this.usuarioLoggedTipe = this.$store.getters.userLogged.tipo;
    this.tipeArchive = ".pdf,.doc,.jpg,.png";

    //this.loadDataProcesos();
    this.loadData();
  },

  methods: {
    
    isContratoCerrado() {
      const contratoCerradoConId = JSON.parse(localStorage.getItem("contratoCerradoConId"));
      if (contratoCerradoConId && contratoCerradoConId.idContrato === this.contratoId) {
        return contratoCerradoConId.cerrado;
      }
      return false;
    },
    async loadDataProcesos() {
      this.genProceso = await this.loadProcesos();
      let proc = [];
      this.genProceso.forEach(function (p) {
        proc.push(p.codigo);
      });
      this.procesoSelect = proc;
      this.procesoValue = this.procesoSelect;
    },

    async loadProcesos() {
      return await axios
        .get("/administracion/allProcess/" + this.contratoId)
        .then((response) => {
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
          return [];
        });
    },

    submit() {
      this.$v.$touch();
    },

    saveDocument() {
      this.loading = true;
      if (
        this.base64Value != null &&
        this.asuntoDocumento != null &&
        this.base64Value != "" &&
        this.base64Value !== undefined &&
        this.asuntoDocumento !== undefined
      ) {
        let base64EncodedStr = this.base64Value;

        this.body = {
          asunto: this.asuntoDocumento,
          filename: this.filenameValue,
          documento: base64EncodedStr,
        };
        axios
          .post("/infocontractual/update", this.body)
          .then((res) => {
            this.resp = res.data;
            window.getApp.$emit("APP_SAVE");
            this.loading = false;
          })
          .then((rel) => {
            this.reloadAdmin();
          })
          .catch((error) => {
            if (error) {
              console.log(error.response.data);
              window.getApp.$emit(
                "ERROR_EXCEPTION",
                error.response.data.message
              );
              this.loading = false;
            }

            return [];
          });
      } else {
        window.getApp.$emit("APP_ADMIN_FIELD");
        this.loading = false;
      }
    },
    async loadProveedoresFilter() {
      this.body = {
        servicio: null,
        periodo: null,
        proveedor: null,
        estado: null,
        subProceso: "",
        idContrato:
          this.idContratoValue && this.idContratoValue != null
            ? this.idContratoValue
            : null,
        proceso: null,
      };
      return await axios
        .post("/contratos/filter", this.body)
        .then(function (response) {
          return response.data;
        })
        .catch((error) => {
          if (error) {
            console.log(error.response.data);
          }
        });
    },
    async loadData() {
      this.loading = true;
      this.itemsProveedor = await this.loadProveedoresFilter();
      this.loadContratoSelect();
      this.loading = false;
    },
    loadContratoSelect() {
      let id = [];
      this.itemsProveedor.forEach(function (p) {
        let index = id.findIndex((x) => x.id == p.id);
        if (index === -1) {
          id.push({ nombre: p.codigo, code: p.id });
        }
      });
      this.idContratoSelect = id;
    },

    reloadAdmin() {
      this.procesoValue = "";
      this.asuntoDocumento = "";
      this.adminGrid += 1;
      this.adminAdjunto += 11;
    },
  },
};
</script>
